// extracted by mini-css-extract-plugin
export default {"frame":"Rgu9ZWSl6wcpMQSt4e2S","frameBody":"a5OrYu5Enh4LaDrp0n_Q","frameHeader":"uVIOZDxghoUeotummOWQ","frameSidebar":"pr65MUCqicvLrxrQSvF3","frameContent":"HLUJIbLPJ2Yf4StmNOXS"};